import React from "react";
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/styles";
import {Icon, Paper} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: 60,
        height: 60,
        textAlign: 'center',
        paddingTop: '5px',
        margin: '5px',
        border: '1px solid transparent',
        position: 'relative',
        '&:hover': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.primary.main}`,
            '& $deleteIcon': {
                visibility: 'visible'
            }
        }
    },
    deleteIcon: {
        position: 'absolute',
        padding: 0, top: -10, right: -10,
        visibility: 'hidden'
    },
    label: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        height: 20
    }
}));

const wrapperInfo = {
    entity: {
        label: "Entity",
        icon: "select_all"
    },
    context: {
        label: "Context",
        icon: "menu"
    },
    interval: {
        label: "Interval",
        icon: 'timer'
    },
    webSocket: {
        label: "Web Socket",
        icon: "settings_ethernet"
    },
    dataSource: {
        label: "Data Source",
        icon: "source"
    },
    shortcut: {
        label: "Shortcut",
        icon: "source"
    }
};

const ComponentWrapper = ({type, label, onSelect, onDelete}) => {
    const classes = useStyles();
    return (
        <Tooltip title={label ? label : wrapperInfo[type].label}>
            <Paper className={classes.paper} onClick={onSelect}>
                <DeleteIcon onClick={(e) => {e.stopPropagation(); onDelete()}} type={type}/>
                <Icon>{wrapperInfo[type].icon}</Icon>
                <div className={classes.label}>{label ? label : wrapperInfo[type].label}</div>
            </Paper>
        </Tooltip>
    )
};

export default ComponentWrapper

ComponentWrapper.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

const DeleteIcon = ({onClick, type}) => {
    const classes = useStyles();
    return (
        <Tooltip title={`Delete ${type}`}>
            <Icon
                fontSize={"small"}
                onClick={onClick}
                className={classes.deleteIcon}
                color={"secondary"}
            >
                clear
            </Icon>
        </Tooltip>
    )
};